import { render, staticRenderFns } from "./fraude.vue?vue&type=template&id=7def5d5b&scoped=true&"
import script from "./fraude.vue?vue&type=script&lang=js&"
export * from "./fraude.vue?vue&type=script&lang=js&"
import style0 from "./fraude.vue?vue&type=style&index=0&id=7def5d5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def5d5b",
  null
  
)

export default component.exports